export const openBlockageEnTranslations = {
  // Route component
  loading: 'Loading...',
  noFeedbackFormData: 'No feedback form data',
  noFeedbackCreator: 'No feedback creator',
  noFeedbackReceiver: 'No feedback receiver',
  waitingFor: 'Waiting for',
  toSeeTheFeedbackYouSent: 'to see the feedback you sent',
  notAllowedToViewFeedback: 'Not allowed to view this feedback',
  conversationDetails: 'Conversation Details',
  actionPlan: 'Action Plan',
  errorUpdatingFeedback: 'Error updating feedback:',

  // Conversation Details
  yes: 'Yes',
  no: 'No',
  hi: 'Hi',
  youveReceivedRequestFrom: (name: string) =>
    `You've received a request from ${name}.`,
  readDetailsInvitation:
    'We invite you to read here the details And hope that both of you will generate significant value in the process.',
  detailsOfEvent: 'Details of the event:',
  wantsToProvideFeedback: 'wants to provide feedback for:',
  thatDidNotOccurOn: 'that did not occur on',
  descriptionOfIssue: (name: string) => `${name}'s description of the issue:`,
  areEventDetailsClear: 'Are the event details clear to you?',
  impactOnGoals: (name: string) => `Impact on ${name}'s goals`,
  accordingToImpact: (name: string, reason: string) =>
    `According to ${name}'s, the impact of ${reason}, on the chances of achieving ${name}'s goal`,
  is: 'is',
  relativelyReduced: 'Relatively reduced',
  significantlyReduced: 'Significantly reduced',
  extremelyReduced: 'Extremely reduced',
  furtherImpact: 'Further Effects',
  isItClearHowGoalsAffected: (name: string) =>
    `Is it clear to you the affection on ${name}'s goals?`,
  accordingToCompanyValue: (name: string) =>
    `According to ${name}, the company value`,
  areCompromised: 'are compromised',
  isCompromised: 'is compromised',
  isItClearHowAffected: (name: string) =>
    `Is it clear to you how ${name} is affected?`,
  nowThatRequestIsClear: (name: string) =>
    `Now that the requests is clear to you, would you help ${name}`,

  // Action Plan
  hereYouCanBuild: 'Here you can build your action plan in 3 easy steps:',
  writeActionsThatHelp: (name: string) =>
    `Write the actions which you believe will help ${name}.`,
  ifYouNeedHelp: (name: string) =>
    `If you need help from ${name}, it is best to write the actions in ${name}'s section (on the right).`,
  doneIsItReady: (name: string) =>
    `Done? Is the action plan ready? You can now send it to ${name} for approval`,
  due: 'Due:',
  enterTaskDescription: 'Enter task description...',
  enterNewTaskDescription: 'Enter new task description...',
  selectDueDate: 'Select due date (optional)',
  addTask: 'Add Task',
  sendActionPlan: 'Send Action Plan',
  sendApproveActionPlan: 'Send Approved Action Plan',
  closedAt: 'Interaction closed at:',
  waitingForOtherPersonToAddTasks: (name: string) =>
    `Please wait for ${name} to add their tasks before you can add yours.`,
  actionPlanPendingApprovalTitle: 'Action Plan Pending Approval',
};
